<template>
  <client-only>
    <v-skeleton-loader v-if="props.isUserInfoSkeletonShown" v-bind="skeletonProps" />
    <div v-else-if="membershipLevelName" class="wd-flex wd-items-center" :class="props.class">
      <funnow-icon class="wd-mr-1" max-width="24" height="24" :image-path="membershipLevelIcon" />
      <span :class="[membershipLevelColorClass, props.membershipLevelNameClass]">{{ membershipLevelName }}</span>
    </div>

    <template #fallback>
      <v-skeleton-loader v-bind="skeletonProps" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import FunnowIcon from '@/components/icons/funnow-icon.vue'

interface Props {
  isUserInfoSkeletonShown: boolean
  membershipLevelIcon: string
  membershipLevelName?: string
  class?: ClassType
  membershipLevelColorClass?: ClassType
  membershipLevelNameClass?: ClassType
}

const props = defineProps<Props>()

const skeletonProps = computed(() => ({ class: 'wd-h-6 wd-w-32', type: 'ossein' }))
</script>
